export const getMembershipTableTemplate = (item) => {
  const membershipObj = {
    1: {
      title: item.unlock_date,
    },
    2: {
      title: item.order_id,
    },
    3: {
      title: item.res_name,
    },
    4: {
      title: item.savings,
    },
  };

  return membershipObj;
};
